import { Injectable } from '@angular/core';
import { S3 } from 'aws-sdk';
import { environment as env, environment } from 'src/environments/environment';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
    Observable,
    catchError,
    firstValueFrom,
    forkJoin,
    from,
    lastValueFrom,
    map,
    switchMap,
} from 'rxjs';
import { LoaderService } from './loader.service';
import Swal from 'sweetalert2';
@Injectable({
    providedIn: 'root',
})
export class UploadFileService {
    private baseUrl = 'http://localhost:8080';
    private apiUrl =
        'https://a0g5khi8r9.execute-api.us-east-1.amazonaws.com/default/ctm-generate-s3-presigned-url';
    private s3!: S3;
    constructor(
        private http: HttpClient,
        private firestore: AngularFirestore,
        private loader: LoaderService,
    ) {
        // this.s3 = new S3({
        //     accessKeyId: env.credentails.accessKeyId,
        //     secretAccessKey: env.credentails.secretAccessKey,
        //     region: env.credentails.region,
        // });
    }

    // uploadFileToS3(
    //     file: any,
    //     path: string,
    //     fileConvertType: any,
    //     metadata: any
    // ) {
    //     console.log('[S3 Upload] Starting upload process');
    //     console.log('[S3 Upload] File convert type:', fileConvertType);
    //     console.log('[S3 Upload] Path:', path);

    //     let bucket = env.credentails.bucketName;
    //     let params: any;

    //     if (fileConvertType == 1) {
    //         console.log('[S3 Upload] Using accesscast-mvp-audio-detection bucket');
    //         bucket = 'accesscast-mvp-audio-detection';
    //         params = {
    //             Bucket: bucket,
    //             Key: path,
    //             Body: file,
    //             ContentType: file.type,
    //             Metadata: metadata,
    //         };
    //     } else if (fileConvertType == 2) {
    //         console.log('[S3 Upload] Using audio-description bucket');
    //         bucket = 'accesscast-mvp-ctm-p3-audio-description';
    //         params = {
    //             Bucket: bucket,
    //             Key: path,
    //             Body: file,
    //             ContentType: file.type,
    //             Metadata: metadata,
    //         };
    //     } else if (fileConvertType == 3) {
    //         console.log('[S3 Upload] Using accesscast-mvp-dialog-sheets bucket');
    //         bucket = 'accesscast-mvp-dialog-sheets';
    //         params = {
    //             Bucket: bucket,
    //             Key: path,
    //             Body: file,
    //             ContentType: file.type,
    //             Metadata: metadata,
    //         };
    //     } else {
    //         console.log('[S3 Upload] Using default bucket');
    //         params = {
    //             Bucket: bucket,
    //             Key: path,
    //             Body: file,
    //             ContentType: file.type,
    //             Metadata: metadata, // Adding metadata for consistency
    //         };
    //     }

    //     console.log('[S3 Upload] Upload parameters:', params);

    //     return new Promise((resolve, reject) => {
    //         this.s3.upload(params, function (err: any, data: any) {
    //             if (err) {
    //                 console.error('[S3 Upload] Error during upload:', err);
    //                 reject(err);
    //             } else {
    //                 console.log('[S3 Upload] Upload successful:', data);
    //                 resolve(data);
    //             }
    //         });
    //     });
    // }

    // uploadFileToS3(
    //     file: any,
    //     path: string,
    //     fileConvertType: number,
    //     metadata: any
    // ) {
    //     return new Promise((resolve, reject) => {
    //         const formData = new FormData();
    //         formData.append('file', file);
    //         formData.append('path', path);
    //         formData.append('fileConvertType', fileConvertType.toString());
    //         formData.append('metadata', JSON.stringify(metadata));

    //         firstValueFrom(
    //             this.http.post<any>(
    //                 environment.firebaseCloudfunction.uploadFileToS3Function,
    //                 formData
    //             )
    //         )
    //             .then(resolve)
    //             .catch(reject);
    //     });
    // }

    uploadFileToS3(
        file: any,
        path: string,
        fileConvertType: number,
        metadata: any,
    ) {
        return new Promise(async (resolve, reject) => {
            try {
                // Step 1: Get pre-signed URL from Firebase function
                const requestBody = {
                    fileName: file.name,
                    mimeType: file.type || 'video/mp4',
                    path: path,
                    fileConvertType: fileConvertType,
                    metadata: metadata,
                };
                const urlResponse = await firstValueFrom(
                    this.http.post<any>(
                        environment.firebaseCloudfunction
                            .uploadFileToS3Function,
                        requestBody,
                    ),
                );
                if (!urlResponse.success || !urlResponse.uploadUrl) {
                    throw new Error('Failed to get upload URL');
                }
                console.log(
                    '[S3 Upload] Pre-signed URL received, uploading directly to S3...',
                );
                // Step 2: Upload file directly to S3 using pre-signed URL
                await firstValueFrom(
                    this.http.put(urlResponse.uploadUrl, file, {
                        headers: {
                            'Content-Type': file.type || 'video/mp4',
                        },
                    }),
                );
                console.log('[S3 Upload] Direct S3 upload successful');
                // Step 3: Return result in same format as before for backward compatibility
                resolve({
                    Location: `https://${urlResponse.bucket}.s3.amazonaws.com/${urlResponse.key}`,
                    Bucket: urlResponse.bucket,
                    Key: urlResponse.key,
                    success: true,
                });
            } catch (error) {
                console.error('[S3 Upload] Error during upload:', error);
                reject(error);
            }
        });
    }

    convertBlobToString(chunkBlob: any) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = function (event) {
                console.log(event.target, 'result from onload');
                // Convert Blob to a string representation (data URL)
                const chunkAsString = event.target?.result;

                // Resolve the Promise with the string representation
                resolve(chunkAsString);
            };

            reader.onerror = function (error) {
                // Reject the Promise if there's an error
                reject(error);
            };

            // Start reading the Blob
            reader.readAsDataURL(chunkBlob);
        });
    }

    // uploadCompanyProfile(file: any, path: string) {
    //     const params = {
    //         Bucket: 'contech-media-company-logo',
    //         Key: path,
    //         Body: file,
    //         ContentType: file.type,
    //     };
    //     return new Promise((resolve, reject) => {
    //         this.s3.upload(params, function (err: any, data: any) {
    //             if (err) {
    //                 reject(false);
    //             } else {
    //                 resolve(data);
    //             }
    //         });
    //     });
    // }

    uploadCompanyProfile(file: File, path: string) {
        return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('path', path);
            firstValueFrom(
                this.http.post<any>(
                    environment.firebaseCloudfunction
                        .uploadCompanyProfileFunction,
                    formData,
                ),
            )
                .then(resolve)
                .catch(reject);
        });
    }

    // async getImage(key: string): Promise<string> {
    //     const params = {
    //         Bucket: 'contech-media-company-logo',
    //         Key: key,
    //     };
    //     try {
    //         const url = await new Promise<string>((resolve, reject) => {
    //             this.s3.getSignedUrl('getObject', params, (err, url) => {
    //                 if (err) {
    //                     console.error('Error getting S3 signed URL:', err);
    //                     reject(err);
    //                 } else {
    //                     resolve(url);
    //                 }
    //             });
    //         });

    //         return url;
    //     } catch (error) {
    //         throw new Error('Failed to get image URL from S3: ' + error);
    //     }
    // }

    async getImage(key: string): Promise<string> {
        const params = {
            Bucket: 'contech-media-company-logo',
            Key: key,
        };

        return firstValueFrom(
            this.http.post<string>(
                environment.firebaseCloudfunction.getSignedUrlFunction,
                params,
            ),
        );
    }

    getGcpData(uid: any) {
        return this.http.post<any>(
            `${environment.firebaseCloudfunction.getGCP}`,
            uid,
        );
    }

    // generatePresignedUrl(
    //     bucketName: string,
    //     key: string,
    //     credientals: any
    // ): Promise<string> {
    //     // console.log(credientals,'cred') //cred
    //     if (
    //         credientals != '' &&
    //         credientals.accessKeyId != '' &&
    //         credientals.secretAccessKey != '' &&
    //         credientals.region != ''
    //     ) {
    //         this.s3 = new S3({
    //             accessKeyId: credientals.accessKeyId,
    //             secretAccessKey: credientals.secretAccessKey,
    //             region: credientals.region,
    //         });
    //     }
    //     //const expirationSeconds = 3600 * 24 * 365 * 10;
    //     //Injozi Update - timeframe set to 7 days and not 10 years
    //     const expirationSeconds = 3600 * 24 * 7;

    //     const params = {
    //         Bucket: bucketName,
    //         Key: key,
    //         Expires: expirationSeconds,
    //     };
    //     console.log(params, 'signedurl');
    //     return new Promise((resolve, reject) => {
    //         this.s3.getSignedUrl(
    //             'getObject',
    //             params,
    //             (err: any, url: string) => {
    //                 if (err) {
    //                     reject(err);
    //                 } else {
    //                     resolve(url);
    //                 }
    //             }
    //         );
    //     });
    // }

    generatePresignedUrl(
        bucketName: string,
        key: string,
        credientals: any,
    ): Promise<string> {
        // console.log(credientals,'cred') //cred
        if (
            credientals != '' &&
            credientals.accessKeyId != '' &&
            credientals.secretAccessKey != '' &&
            credientals.region != ''
        ) {
            this.s3 = new S3({
                accessKeyId: credientals.accessKeyId,
                secretAccessKey: credientals.secretAccessKey,
                region: credientals.region,
            });
        }
        //const expirationSeconds = 3600 * 24 * 365 * 10;
        //Injozi Update - timeframe set to 7 days and not 10 years
        const expirationSeconds = 3600 * 24 * 7;

        const params = {
            Bucket: bucketName,
            Key: key,
            Expires: expirationSeconds,
        };
        console.log(params, 'signedurl');
        return firstValueFrom(
            this.http.post<string>(
                environment.firebaseCloudfunction.getSignedUrlFunction,
                params,
            ),
        );
    }

    // generatePresignedUrl(bucketName: string, key: string, credentials: any): Promise<string> {
    //   const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    //   const body = { bucketName, key };

    //   // Convert Observable to Promise
    //   return lastValueFrom(
    //     this.http.post<{ url: string }>(this.apiUrl, JSON.stringify(body), { headers }).pipe(
    //       map((response) => response.url)
    //     )
    //   );
    // }

    // uploadFile(file: File, key: string): Promise<S3.ManagedUpload.SendData> {
    //     const params: S3.PutObjectRequest = {
    //         Bucket: environment.credentails.bucketName,
    //         Key: key,
    //         Body: file,
    //         // ACL: "private",
    //         ContentType: file.type,
    //     };

    //     return this.s3.upload(params).promise();
    // }

    uploadFile(file: File, key: string) {
        return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('key', key);

            firstValueFrom(
                this.http.post<any>(
                    environment.firebaseCloudfunction.uploadFileFunction,
                    formData,
                ),
            )
                .then(resolve)
                .catch(reject);
        });
    }

    async updateNameInMetaData(
        uid: string,
        workspaceId: string,
        docId: string,
        newName: string,
    ): Promise<void> {
        try {
            const response = await this.http
                .patch<any>(
                    `${environment.backendApiUrl}/api/v1/metadata/${docId}?user_id=${uid}&workspace_id=${workspaceId}`,
                    {
                        character_name: newName,
                    },
                )
                .toPromise();

            if (response && response.success) {
                console.log(`Metadata with ID ${docId} updated successfully.`);
            } else {
                throw new Error(response?.error || 'Failed to update metadata');
            }
        } catch (error) {
            console.error('Error updating metadata:', error);
            throw error;
        }
    }

    async uploadImage(files: any[], uid: string, workspaceId: string) {
        try {
            // Separate items with files from those without
            const itemsWithFiles = files.filter((item) => item.file);
            const itemsWithoutFiles = files.filter((item) => !item.file);

            const results: any[] = [];

            // Handle items with files - use upload-image endpoint
            if (itemsWithFiles.length > 0) {
                const uploadPromises = itemsWithFiles.map(async (item) => {
                    const formData = new FormData();
                    formData.append('file', item.file);
                    formData.append('character_name', item.characterName || '');
                    formData.append('actor_name', item.actorName || '');
                    formData.append('user_id', uid);
                    formData.append('workspace_id', workspaceId);

                    const response = await this.http
                        .post<any>(
                            `${environment.backendApiUrl}/api/v1/metadata/upload-image`,
                            formData,
                        )
                        .toPromise();

                    return response;
                });

                const fileResults = await Promise.all(uploadPromises);
                results.push(...fileResults);
            }

            // Handle items without files - use bulk-create endpoint
            if (itemsWithoutFiles.length > 0) {
                const metadata = itemsWithoutFiles.map((item) => ({
                    character_name: item.characterName || '',
                    actor_name: item.actorName || '',
                    image_url: '',
                    image_type: '',
                }));

                const bulkResponse = await this.http
                    .post<any>(
                        `${environment.backendApiUrl}/api/v1/metadata/bulk-create`,
                        {
                            user_id: uid,
                            workspace_id: workspaceId,
                            metadata: metadata,
                        },
                    )
                    .toPromise();

                if (bulkResponse && bulkResponse.success && bulkResponse.data) {
                    // Transform bulk create response to match upload-image response format
                    const bulkResults =
                        bulkResponse.data.metadata_ids?.map((id: string) => ({
                            success: true,
                            data: { id },
                        })) || [];
                    results.push(...bulkResults);
                }
            }

            console.log('All metadata created successfully:', results);

            return results
                .map((r: any) => r?.data?.id || null)
                .filter((id: any) => id !== null);
        } catch (error) {
            console.error('Upload failed:', error);
            throw error;
        }
    }

    getImageNameFromUrl(url: string): string {
        const urlParts = url.split('/');
        return urlParts[urlParts.length - 1].split('?')[0]; // Remove query parameters if any
    }

    async uploadImagesToS3(
        data: any[],
        uid: string,
        workspaceId: string,
    ): Promise<any> {
        try {
            // Transform data to backend format
            const metadata = data.map((item) => ({
                character_name: item.character,
                actor_name: item.actor,
                image_url: item.image_url,
                image_type: item.image_url?.startsWith('http') ? 'tmdb' : 's3',
                tmdb_cast_id: item.cast_id,
            }));

            // Call backend API to bulk create metadata
            const response = await this.http
                .post<any>(
                    `${environment.backendApiUrl}/api/v1/metadata/bulk-create`,
                    {
                        user_id: uid,
                        workspace_id: workspaceId,
                        metadata: metadata,
                    },
                )
                .toPromise();

            if (response && response.success && response.data) {
                return response.data.metadata_ids || [];
            } else {
                throw new Error(response?.error || 'Failed to create metadata');
            }
        } catch (error) {
            console.error('Upload failed:', error);
            throw error;
        }
    }

    transformData(
        cast: any[],
        s3Responses: S3.ManagedUpload.SendData[],
    ): any[] {
        return cast.map((item, index) => ({
            Files: {
                Bucket: 'accesscast-mvp-audio-detection',
                Key: s3Responses[index].Key,
                Name: item.character,
            },
        }));
    }

    replaceSpacesWithUnderscores(inputString: string): string {
        const parts = inputString.split('.');
        const extension = parts.pop();
        const fileName = parts
            .join('.')
            .replace(/ /g, '_')
            .replace(/[().]/g, '');
        return `${fileName}.${extension}`;
    }

    async saveMetaData(
        uid: string,
        workspaceId: string,
        data: any,
    ): Promise<any> {
        try {
            const promises = data.map(async (item: any) => {
                const d = { Files: item };
                const userDocRef = this.firestore
                    .collection('users')
                    .doc(uid)
                    .collection('workspaces')
                    .doc(workspaceId);
                const newCollectionRef = userDocRef.collection('imagesData');
                const querySnapshot = await newCollectionRef.ref.get();
                const existingQuery = querySnapshot.docs.find((doc: any) => {
                    return doc.data().Files.Name.trim() === d.Files.Name.trim();
                });

                // Save new data in the new collection and wait for the promise to resolve
                if (existingQuery) {
                    return Swal.fire({
                        title: 'Error',
                        text: 'Character already exists.',
                        confirmButtonText: 'Ok',
                        customClass: {
                            title: 'custom-title',
                            popup: 'custom-popup',
                            confirmButton: 'custom-button',
                        },
                    });
                } else {
                    const docRef = await newCollectionRef.add(d);

                    console.log('New document added with ID:', docRef.id);
                    return docRef.id;
                }
                // Return the document ID
            });

            // Wait for all promises to resolve
            const results = await Promise.all(promises);

            console.log('All documents saved:', results);

            // Return the array of document IDs
            return results;
        } catch (error) {
            console.error('Error saving data array:', error);
            // Optionally, throw the error or handle it differently
            throw error;
        }
    }

    // multipleFiles(
    //     files: File[],
    //     keyPrefix: string,
    //     fileConvertType: number,
    //     refId: any
    // ): Promise<S3.ManagedUpload.SendData[]> {
    //     console.log('[multipleFiles] Starting multiple file upload process', {
    //         numberOfFiles: files.length,
    //         keyPrefix,
    //         fileConvertType,
    //         refId,
    //     });

    //     let bucket: string = ' accesscast-mvp-movie-subtitle-video-upload';

    //     // Set bucket based on fileConvertType
    //     switch (fileConvertType) {
    //         case 1:
    //             bucket = 'accesscast-mvp-audio-detection';
    //             console.log('[multipleFiles] Selected audio detection bucket');
    //             break;
    //         case 2:
    //             bucket = 'accesscast-mvp-ctm-p3-audio-description';
    //             console.log(
    //                 '[multipleFiles] Selected audio description bucket'
    //             );
    //             break;
    //         case 3:
    //             bucket = 'accesscast-mvp-dialog-sheets';
    //             console.log('[multipleFiles] Selected dialog sheets bucket');
    //             break;
    //         case 0:
    //         default:
    //             bucket = ' accesscast-mvp-movie-subtitle-video-upload';
    //             console.log(
    //                 '[multipleFiles] Selected default video upload bucket'
    //             );
    //             break;
    //     }

    //     console.log(`[multipleFiles] Using bucket: ${bucket}`);

    //     const uploadPromises = files.map((file, index) => {
    //         console.log(
    //             `[multipleFiles] Processing file ${index + 1}/${files.length}`,
    //             {
    //                 fileName: file.name,
    //                 fileSize: file.size,
    //                 fileType: file.type,
    //             }
    //         );

    //         const name = file.name;
    //         // Create path using userid first, then workspaceid from metadata
    //         const key = `${keyPrefix}/${refId.userid}/${refId.workspaceid}/${name}`;

    //         const params: S3.PutObjectRequest = {
    //             Bucket: bucket,
    //             Key: key,
    //             Body: file,
    //             ContentType: file.type,
    //             Metadata: refId,
    //         };

    //         console.log(
    //             `[multipleFiles] Prepared upload params for ${file.name}:`,
    //             params
    //         );

    //         const uploadPromise = this.s3
    //             .upload(params)
    //             .promise()
    //             .then((result) => {
    //                 console.log(
    //                     `[multipleFiles] Successfully uploaded ${file.name}`,
    //                     result
    //                 );
    //                 return result;
    //             })
    //             .catch((error) => {
    //                 console.error(
    //                     `[multipleFiles] Failed to upload ${file.name}:`,
    //                     error
    //                 );
    //                 throw error;
    //             });

    //         return uploadPromise;
    //     });

    //     console.log('[multipleFiles] Initiating parallel upload of all files');
    //     return Promise.all(uploadPromises)
    //         .then((results) => {
    //             console.log('[multipleFiles] All files uploaded successfully', {
    //                 numberOfFiles: results.length,
    //             });
    //             return results;
    //         })
    //         .catch((error) => {
    //             console.error(
    //                 '[multipleFiles] Error during batch upload:',
    //                 error
    //             );
    //             throw error;
    //         });
    // }

    async multipleFiles(
        files: File[],
        keyPrefix: string,
        fileConvertType: number,
        refId: any,
    ): Promise<any[]> {
        const requestBody = {
            files: files.map((f) => ({ name: f.name, type: f.type })),
            keyPrefix,
            fileConvertType,
            refId,
        };

        const response = await firstValueFrom(
            this.http.post<any>(
                environment.firebaseCloudfunction.getMultipleFilesUrls,
                requestBody,
            ),
        );

        const uploadedResults: any[] = [];

        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const { url, key } = response.urls[i];

            await fetch(url, {
                method: 'PUT',
                body: file,
                headers: { 'Content-Type': file.type },
            });

            uploadedResults.push({ key, name: file.name });
        }

        return uploadedResults;
    }

    async uploadLinkToS3(
        dataArray: any[],
        fileConvertType: number,
        refId: any,
    ): Promise<S3.ManagedUpload.SendData[]> {
        try {
            const requestBody = { dataArray, fileConvertType, refId };
            const response = await firstValueFrom(
                this.http.post<S3.ManagedUpload.SendData[]>(
                    environment.firebaseCloudfunction.uploadLinkToS3,
                    requestBody,
                ),
            );
            return response;
        } catch (error) {
            console.error('[uploadLinkToS3] Error uploading files:', error);
            throw error;
        }
    }

    // async uploadLinkToS3(
    //     dataArray: any[],
    //     fileConvertType: any,
    //     refId: any
    // ): Promise<S3.ManagedUpload.SendData[]> {
    //     console.log(
    //         '[uploadLinkToS3] Starting upload process with fileConvertType:',
    //         fileConvertType
    //     );

    //     const uploadPromises: Promise<S3.ManagedUpload.SendData>[] = [];
    //     let bucket: string;

    //     switch (fileConvertType) {
    //         case 1:
    //             bucket = 'accesscast-mvp-audio-detection';
    //             console.log('[uploadLinkToS3] Using audio detection bucket');
    //             break;
    //         case 2:
    //             bucket = 'accesscast-mvp-ctm-p3-audio-description';
    //             console.log('[uploadLinkToS3] Using audio description bucket');
    //             break;
    //         case 3:
    //             bucket = 'accesscast-mvp-dialog-sheets';
    //             console.log('[uploadLinkToS3] Using dialog sheets bucket');
    //             break;
    //         case 0:
    //         default:
    //             bucket = ' accesscast-mvp-movie-subtitle-video-upload';
    //             console.log(
    //                 '[uploadLinkToS3] Using default video upload bucket'
    //             );
    //             break;
    //     }

    //     console.log('[uploadLinkToS3] Selected bucket:', bucket);

    //     for (const data of dataArray) {
    //         uploadPromises.push(
    //             this.uploadToS3(
    //                 data.data,
    //                 data.filename,
    //                 bucket,
    //                 fileConvertType,
    //                 refId
    //             )
    //         );
    //     }

    //     return Promise.all(uploadPromises);
    // }

    // private async uploadToS3(
    //     data: string,
    //     filename: string,
    //     bucket: string,
    //     fileType: number,
    //     refId: any
    // ): Promise<S3.ManagedUpload.SendData> {
    //     try {
    //         console.log('[uploadToS3] Starting upload process', {
    //             filename,
    //             bucket,
    //             fileType,
    //         });

    //         // Update key path to put userid before workspaceid
    //         const key = `uploadvideo/${refId.userid}/${refId.workspaceid}/${filename}`;
    //         console.log('[uploadToS3] Generated key path:', key);

    //         // Fetch blob data
    //         console.log('[uploadToS3] Fetching blob data from URL');
    //         const blobData: any = await this.http
    //             .get(data, { responseType: 'blob' })
    //             .toPromise();

    //         // Common params for all file types
    //         const params: S3.PutObjectRequest = {
    //             Bucket: bucket,
    //             Key: key,
    //             Body: blobData,
    //             ContentType: 'video/mp4',
    //             Metadata: refId,
    //         };

    //         console.log('[uploadToS3] Prepared upload params:', {
    //             Bucket: params.Bucket,
    //             Key: params.Key,
    //             ContentType: params.ContentType,
    //             Metadata: params.Metadata,
    //         });

    //         // Upload to S3
    //         console.log('[uploadToS3] Initiating upload to S3');
    //         const result = await this.s3.upload(params).promise();

    //         console.log('[uploadToS3] Upload successful:', {
    //             Location: result.Location,
    //             Key: result.Key,
    //             Bucket: result.Bucket,
    //         });

    //         return result;
    //     } catch (error) {
    //         console.error('[uploadToS3] Error during upload:', {
    //             error,
    //             filename,
    //             bucket,
    //             fileType,
    //         });
    //         throw error;
    //     }
    // }

    uploadGCPtoS3(
        dataArray: any[],
        fileConvertType: any,
        refId: any,
    ): Observable<any[]> {
        this.uid = localStorage.getItem('uid');
        const uploadObservables: Observable<any>[] = dataArray.map((data) => {
            data['bucket'] = ' accesscast-mvp-movie-subtitle-video-upload';
            data['fileType'] = fileConvertType;
            data['refId'] = refId; // Add refId for all file types
            if (fileConvertType == 1) {
                data['bucket'] = 'accesscast-mvp-audio-detection';
            } else if (fileConvertType == 4) {
                // ASD (active speaker detection) — its own feature bucket, following the pattern.
                data['bucket'] =
                    'accesscast-mvp-active-speaker-detection-video-upload';
            }
            data['uid'] = `${this.uid}.json`;
            return this.uploadGCPData(data).pipe(
                catchError((error) => {
                    console.error(
                        `Error uploading file ${data.fileName}:`,
                        error,
                    );
                    throw error;
                }),
            );
        });

        return forkJoin(uploadObservables);
    }

    uploadGCPData(data: any): Observable<any> {
        return this.http.post(
            environment.firebaseCloudfunction.uploadGCPtoS3,
            data,
        );
    }

    uid: any;
    failedUploads: any = [];
    uploadsS3toS3(
        dataArray: any[],
        credentals: any,
        uid: string,
        docId: any[],
        id: string,
        refId: any,
        fileConvertType: any,
    ): Promise<any[]> {
        this.failedUploads = [];
        console.log(dataArray, 'dataArray');
        const uploadPromises: Promise<any>[] = dataArray.map((data) => {
            return new Promise<any>((resolve, reject) => {
                data['refId'] = refId;
                data['fileConvertType'] = fileConvertType;
                this.uploads3Data({ data, credentals }).subscribe({
                    next: (res) => {
                        resolve({ success: true, response: res }); // Resolve the promise with the response when upload succeeds
                    },
                    error: (err) => {
                        console.log(
                            `Error uploading file ${data.fileName}:`,
                            err,
                        );
                        resolve({ success: false, fileName: data.fileName });
                    },
                });
            });
        });

        return Promise.all(uploadPromises)
            .then(async (responses) => {
                console.log(
                    '🎯 [S3-TO-S3] All upload promises completed. Responses:',
                    responses,
                );
                const successfulUploads = responses
                    .filter((response) => response.success)
                    .map((response) => response.response);

                console.log(
                    '✅ [S3-TO-S3] Successful uploads:',
                    successfulUploads,
                );

                const failedUploads = responses.filter(
                    (response) => !response.success,
                );
                if (failedUploads.length > 0) {
                    console.log(
                        '❌ [S3-TO-S3] Processing failed uploads:',
                        failedUploads.length,
                    );
                    await failedUploads.map((x: any) => {
                        // Use correct path format with userid/workspaceid
                        const srtFile = {
                            // bucketName: env.credentails.bucketName,
                            bucketName:
                                ' accesscast-mvp-movie-subtitle-video-upload',
                            path: `uploadvideo/${uid}/${id}/${x.fileName}.mp4`,
                        };
                        console.log(
                            '❌ [S3-TO-S3] Failed upload srtFile path:',
                            srtFile.path,
                        );
                        x.fileName = { fileStatus: 2, srtFile: srtFile };
                    });
                    console.log(
                        '❌ [S3-TO-S3] Failed uploads processed:',
                        failedUploads,
                    );
                    await this.updateMultipleFileData(
                        uid,
                        docId,
                        id,
                        failedUploads,
                    );
                    this.loader.updateVideoStatus(false);
                }
                return successfulUploads;
            })
            .catch((error) => {
                console.error('Error uploading files:', error);
                throw error;
            });
    }

    async updateMultipleFileData(
        uid: string,
        docId: any[],
        id: string,
        newData: any[],
    ): Promise<string> {
        try {
            const docRef = this.firestore
                .collection('users')
                .doc(uid)
                .collection('workspaces')
                .doc(id);
            const idMap = new Map<string, string>();

            for (const data of newData) {
                const filename = data.fileName.srtFile.path
                    .split('/')
                    .pop()!
                    .replace(/\.[^.]+$/, '.srt');
                const matchedId = docId.find(
                    (x) =>
                        x.name === filename ||
                        x.name === filename.replace('.srt', ''),
                );
                if (matchedId) {
                    idMap.set(filename, matchedId.id);
                }
            }

            const updatePromises: Promise<void>[] = [];
            for (const [filename, docId] of idMap.entries()) {
                const docRef2 = docRef.collection('files').doc(docId);
                const upObj = {
                    fileStatus: 3,
                };
                console.log(upObj, 'object for update');
                updatePromises.push(docRef2.update(upObj));
            }

            await Promise.all(updatePromises);
            return 'Updated Successfully';
        } catch (error) {
            console.error('Error saving multiple file data:', error);
            throw error;
        }
    }

    // putObject(key: string, bucketName: string, content: string): Promise<any> {
    //     const params = {
    //         Bucket: bucketName,
    //         Key: key,
    //         Body: content,
    //         ContentType: 'text/plain', // Adjust content type as needed
    //     };

    //     return new Promise((resolve, reject) => {
    //         this.s3.putObject(params, (err, data) => {
    //             if (err) {
    //                 reject(err);
    //             } else {
    //                 resolve(data);
    //             }
    //         });
    //     });
    // }

    putObject(key: string, bucketName: string, content: string): Promise<any> {
        const body = {
            bucketName,
            key,
            content,
        };
        return this.http
            .post(
                `${environment.firebaseCloudfunction.putObjectFunction}`,
                body,
            )
            .toPromise();
    }
    // putJsonObject(
    //     key: string,
    //     bucketName: string,
    //     content: string
    // ): Promise<any> {
    //     const params = {
    //         Bucket: bucketName,
    //         Key: key,
    //         Body: content,
    //         ContentType: 'application/json',
    //     };

    //     return new Promise((resolve, reject) => {
    //         this.s3.putObject(params, (err, data) => {
    //             if (err) {
    //                 console.error('Error uploading object to S3:', err);
    //                 reject(err);
    //             } else {
    //                 console.log('Object uploaded successfully:', data);
    //                 resolve(data);
    //             }
    //         });
    //     });
    // }

    putJsonObject(key: string, bucketName: string, content: any): Promise<any> {
        const body = {
            bucketName,
            key,
            content,
        };
        return this.http
            .post(
                `${environment.firebaseCloudfunction.putJsonObjectFunction}`,
                body,
            )
            .toPromise();
    }

    // getObject(bucketName: string, key: string): Promise<string> {
    //     const params = {
    //         Bucket: bucketName,
    //         Key: key,
    //     };

    //     return new Promise((resolve, reject) => {
    //         this.s3.getObject(params, (err, data) => {
    //             if (data && data.Body) {
    //                 resolve(data.Body.toString('utf-8'));
    //             } else {
    //                 reject(err);
    //             }
    //         });
    //     });
    // }

    async getObject(bucketName: string, key: string): Promise<string> {
        const params = {
            Bucket: bucketName,
            Key: key,
        };

        try {
            const response = await firstValueFrom(
                this.http.post<string>(
                    environment.firebaseCloudfunction.getObjectFunction,
                    params,
                ),
            );
            return response;
        } catch (error) {
            console.error(
                'Error fetching object from S3 via Firebase function:',
                error,
            );
            throw error;
        }
    }

    // getJsonObject(bucketName: string, key: string): Promise<any> {
    //     const params = {
    //         Bucket: bucketName,
    //         Key: key,
    //     };

    //     return new Promise((resolve, reject) => {
    //         this.s3.getObject(params, (err, data) => {
    //             if (err) {
    //                 console.error('Error fetching object from S3:', err);
    //                 reject(err); // Reject with the error
    //             } else {
    //                 try {
    //                     console.log(
    //                         'Successfully fetched object from S3:',
    //                         data
    //                     );

    //                     // Ensure data.Body is handled correctly for browser environments
    //                     if (data.Body) {
    //                         // Convert data.Body (ArrayBuffer) to Uint8Array
    //                         const bodyContent = new Uint8Array(
    //                             data.Body as ArrayBuffer
    //                         );

    //                         // Decode Uint8Array to string
    //                         const jsonString = new TextDecoder('utf-8').decode(
    //                             bodyContent
    //                         );

    //                         // Parse string to JSON
    //                         const jsonData = JSON.parse(jsonString);
    //                         resolve(jsonData); // Resolve with parsed JSON data
    //                     } else {
    //                         throw new Error(
    //                             'S3 object Body is empty or undefined.'
    //                         );
    //                     }
    //                 } catch (error) {
    //                     console.error(
    //                         'Error parsing JSON from S3 object:',
    //                         error
    //                     );
    //                     reject(error); // Reject if JSON parsing fails
    //                 }
    //             }
    //         });
    //     });
    // }

    async getJsonObject(bucketName: string, key: string): Promise<any> {
        const params = {
            Bucket: bucketName,
            Key: key,
        };

        try {
            const response = await firstValueFrom(
                this.http.post(
                    environment.firebaseCloudfunction.getJsonObjectFunction,
                    params,
                ),
            );
            return response;
        } catch (error) {
            console.error(
                'Error fetching object from S3 via Firebase function:',
                error,
            );
            throw error;
        }
    }

    uploads3Data(data: any) {
        return this.http.post(
            environment.firebaseCloudfunction.uploadAWStoAWS,
            data,
        );
    }

    // getAwsTime(data:any){
    //   console.log(data,'from service')
    //   return this.http.post(environment.firebaseCloudfunction.getawstime,data);
    // }
    async getAwsTime(url: string) {
        try {
            console.log('awas time>>>>>');
            const response = await this.http
                .post(environment.firebaseCloudfunction.getawstime, { url })
                .toPromise();
            return response; // Return the response from the server function
        } catch (error) {
            console.error('Error:', error);
            return null; // Return null if an error occurs
        }
    }

    extractDiffrentVoice(data: any): Promise<any> {
        return firstValueFrom(
            this.http.post(environment.lambdaFunction.extractAudio, data),
        );
    }

    processVideoDetctection(data: any): Promise<any> {
        return firstValueFrom(
            this.http.post(
                environment.devFirebaseCloudfunction.processVideoImageDetection,
                data,
            ),
        );
    }
    signedUrl!: string;

    getJsonData(): Observable<any> {
        const params = {
            Bucket: 'trans-output-bucket',
            Key: 'TranscribeJob-1712656881915.json',
            Expires: 300, // Link expiration time in seconds
        };

        return from(this.getSignedUrl(params)).pipe(
            switchMap((url) => this.http.get(url)),
        );
    }

    // async getSignedUrl(params: any): Promise<string> {
    //     return new Promise((resolve, reject) => {
    //         this.s3.getSignedUrl('getObject', params, (err, url) => {
    //             if (err) {
    //                 console.log(err);
    //                 reject('Failed to generate signed URL');
    //             } else {
    //                 resolve(url);
    //             }
    //         });
    //     });
    // }

    async getSignedUrl(params: any): Promise<string> {
        return firstValueFrom(
            this.http
                .post<{
                    url: string;
                }>(
                    environment.firebaseCloudfunction.getSignedUrlFunction,
                    params,
                )
                .pipe(map((response) => response.url)),
        );
    }

    splitVideo(data: any): Observable<any> {
        //@ts-ignore
        return this.http.post<any>(
            `${environment.devFirebaseCloudfunction.splitVideoFile}`,
            data,
        );
    }
}
